"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable: variable-name no-shadowed-variable */
var Lemmon = require("./lemmon");
var IAPWS_95 = require("./iapws-95");
// NB: Using delta = 1E-10 yields the values in the table, using delta = 1E-12 does not!!
//private const double delta_zero = 1e-12;
var delta_zero = 1e-10;
/// <param name="T">Temperature [K]</param>
/// <param name="psi_w">[1/1]</param>
/// <returns>[m3/mol]</returns>
function Get_Bm(T, psi_w) {
    var Baa = Get_Baa(T);
    var Baw = Get_Baw(T);
    var Bww = Get_Bww(T);
    var Bm = Math.pow(1 - psi_w, 2) * Baa + 2 * (1 - psi_w) * psi_w * Baw + Math.pow(psi_w, 2) * Bww;
    return Bm;
}
exports.Get_Bm = Get_Bm;
/// <param name="T">Temperature [K]</param>
/// <param name="psi_w">[1/1]</param>
/// <returns>[m6/mol2]</returns>
function Get_Cm(T, psi_w) {
    var Caaa = Get_Caaa(T);
    var Caaw = Get_Caaw(T);
    var Caww = Get_Caww(T);
    var Cwww = Get_Cwww(T);
    var Cm = Math.pow(1 - psi_w, 3) * Caaa + 3 * Math.pow(1 - psi_w, 2) * psi_w * Caaw +
        3 * (1 - psi_w) * Math.pow(psi_w, 2) * Caww + Math.pow(psi_w, 3) * Cwww;
    return Cm;
}
exports.Get_Cm = Get_Cm;
function Get_dBm_dT(T, psi_w) {
    var dBaa_dT = Get_dBaa_dT(T);
    var dBaw_dT = Get_dBaw_dT(T);
    var dBww_dT = Get_dBww_dT(T);
    var dBm_dT = Math.pow((1 - psi_w), 2) * dBaa_dT + 2 * (1 - psi_w) * psi_w * dBaw_dT + Math.pow(psi_w, 2) * dBww_dT;
    return dBm_dT;
}
exports.Get_dBm_dT = Get_dBm_dT;
function Get_dCm_dT(T, psi_w) {
    var dCaaa_dT = Get_dCaaa_dT(T);
    var dCaaw_dT = Get_dCaaw_dT(T);
    var dCaww_dT = Get_dCaww_dT(T);
    var dCwww_dT = Get_dCwww_dT(T);
    var dCm_dT = Math.pow((1 - psi_w), 3) * dCaaa_dT + 3 * Math.pow((1 - psi_w), 2) * psi_w * dCaaw_dT + 3 * (1 - psi_w) * Math.pow(psi_w, 2) * dCaww_dT +
        Math.pow(psi_w, 3) * dCwww_dT;
    return dCm_dT;
}
exports.Get_dCm_dT = Get_dCm_dT;
/// <param name="T">Temperature [K]</param>
/// <returns>Baa [m3/mol]</returns>
function Get_Baa(T) {
    var rhobar_j = 10.4477 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var delta = delta_zero;
    var T_j = 132.6312; // [K]
    var tau = T_j / T;
    var dalphar_dDelta = Lemmon.Get_dalphar_dDelta(delta, tau);
    var B_aa = (1.0 / rhobar_j) * dalphar_dDelta;
    return B_aa;
}
exports.Get_Baa = Get_Baa;
/// <param name="T">Temperature [K]</param>
/// <returns>Baw [m3/mol]</returns>
function Get_Baw(T) {
    var T_star = 100.0; // [K]
    var theta = T / T_star;
    var rhobar_star = 1E3 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var Baw = (1.0 / rhobar_star) *
        (0.665687E2 * Math.pow(theta, -0.237) +
            (-0.238834E3) * Math.pow(theta, -1.048) +
            (-0.176755E3) * Math.pow(theta, -3.183));
    return Baw;
}
exports.Get_Baw = Get_Baw;
/// <param name="T">Temperature [K]</param>
/// <returns>Bww [m3/mol]</returns>
function Get_Bww(T) {
    var T_c = 647.096; // [K]
    var rho_c = 322; // [kg/m3]
    var M_95 = 18.015268 / 1000; // [kg/kmol] -> [kg/mol]
    var rhobar_c = rho_c / M_95;
    var tau = T_c / T;
    var delta = delta_zero;
    var dAlphar_dDelta = IAPWS_95.Get_dalphar_ddelta_tau(delta, tau);
    var B_ww = (1.0 / rhobar_c) * dAlphar_dDelta;
    return B_ww;
}
exports.Get_Bww = Get_Bww;
/// <param name="T">Temperature [K]</param>
/// <returns>Caaa [m6/mol2]</returns>
function Get_Caaa(T) {
    var T_j = 132.6312; // [K]
    var tau = T_j / T;
    var delta = delta_zero;
    var d2alphar_dDelta2 = Lemmon.Get_d2alphar_dDelta2(delta, tau);
    var rhobar_j = 10.4477 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var Caaa = (1 / Math.pow(rhobar_j, 2)) * d2alphar_dDelta2;
    return Caaa;
}
exports.Get_Caaa = Get_Caaa;
/// <param name="T">Temperature [K]</param>
/// <returns>Caaw [m6/mol2]</returns>
function Get_Caaw(T) {
    var Tstar = 1; // [K]
    var rhobarstar = 1E3 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var theta = T / Tstar;
    var sum = 0;
    var c = [NaN, 0.482737E3, 0.105678E6, -0.656394E8, 0.294442E11, -0.319317E13];
    for (var i = 1; i <= 5; i++) {
        sum += c[i] * Math.pow(theta, 1 - i);
    }
    var Caaw = 1.0 / Math.pow(rhobarstar, 2) * sum;
    return Caaw;
}
exports.Get_Caaw = Get_Caaw;
/// <param name="T">Temperature [K]</param>
/// <returns>Caaw [m6/mol2]</returns>
function Get_Caww(T) {
    var Tstar = 1; // [K]
    // NB: There seems to be an error in RP1485, section 3.3.2.3 says rhobarstar
    // should be 10^3 mol/dm3 for Caww but 1 mol/dm3 seems to yield results in table A.2.
    //double rhobarstar = 1E3 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var rhobarstar = 1 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var theta = T / Tstar;
    var d = [NaN, -0.1072887E2, 0.347804E4, -0.383383E6, 0.334060E8];
    var sum = 0;
    for (var i = 1; i <= 4; i++) {
        sum += d[i] * Math.pow(theta, 1 - i);
    }
    var Caww = -(1.0 / Math.pow(rhobarstar, 2)) * Math.exp(sum);
    return Caww;
}
exports.Get_Caww = Get_Caww;
/// <param name="T">Temperature [K]</param>
/// <returns>Cwww [m6/mol2]</returns>
function Get_Cwww(T) {
    var T_c = 647.096; // [K]
    var rho_c = 322; // [kg/m3]
    var M_95 = 18.015268 / 1000; // [kg/kmol] -> [kg/mol]
    var rhobar_c = rho_c / M_95;
    var tau = T_c / T;
    // NB: Using delta = 1E-10 yields the values in the table, using delta = 1E-12 does not!!
    //double delta = 1E-12;
    var delta = delta_zero;
    //// Can be validated here: http://twt.mpei.ac.ru/mcs/worksheets/iapws/IAPWS95.xmcd
    //var test = IAPWS_95.Get_d2alphar_ddelta2(358 / rho_c, tau);
    var d2alphar_ddelta2 = IAPWS_95.Get_d2alphar_ddelta2(delta, tau);
    var C_www = (1.0 / Math.pow(rhobar_c, 2)) * d2alphar_ddelta2;
    return C_www;
}
exports.Get_Cwww = Get_Cwww;
/// <param name="T">Temperature [K]</param>
/// <returns>Baw [m3/(mol*K)]</returns>
function Get_dBaa_dT(T) {
    var rhobar_j = 10.4477 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var delta = delta_zero;
    var T_j = 132.6312; // [K]
    var tau = T_j / T;
    var d2alphar_ddelta_dtau = Lemmon.Get_d2alphar_ddelta_dtau(delta, tau);
    var dBaa_dT = -1.0 / (rhobar_j * T_j) * Math.pow(tau, 2) * d2alphar_ddelta_dtau;
    return dBaa_dT;
}
exports.Get_dBaa_dT = Get_dBaa_dT;
/// <param name="T">Temperature [K]</param>
/// <returns>Baw [m3/(mol*K)]</returns>
function Get_dBaw_dT(T) {
    var T_star = 100.0; // [K]
    var theta = T / T_star;
    var rhobar_star = 1E3 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var dBaw_dT = 1.0 / (rhobar_star * T_star) *
        (0.665687E2 * -0.237 * Math.pow(theta, -0.237 - 1) + (-0.238834E3) * -1.048 * Math.pow(theta, -1.048 - 1) +
            (-0.176755E3) * -3.183 * Math.pow(theta, -3.183 - 1));
    return dBaw_dT;
}
exports.Get_dBaw_dT = Get_dBaw_dT;
function Get_dBww_dT(T) {
    var M_95 = 18.015268 / 1000; // [kg/kmol] -> [kg/mol]
    var T_c = 647.096; // [K]
    var rho_c = 322; // [kg/m3]
    var tau = T_c / T;
    var rhobar_c = rho_c / M_95;
    var delta = delta_zero;
    var d2alphar_ddelta_dtau = IAPWS_95.Get_d2alphar_ddelta_dtau(delta, tau);
    var dBww_dT = -1.0 / (rhobar_c * T_c) * Math.pow(tau, 2) * d2alphar_ddelta_dtau;
    return dBww_dT;
}
exports.Get_dBww_dT = Get_dBww_dT;
function Get_dCaaa_dT(T) {
    var T_j = 132.6312; // [K]
    var tau = T_j / T;
    var delta = delta_zero;
    var d3alphar_ddelta2_dtau = Lemmon.Get_d3alphar_ddelta2_dtau(delta, tau);
    var rhobar_j = 10.4477 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var dCaaa_dT = -1.0 / (Math.pow(rhobar_j, 2) * T_j) * Math.pow(tau, 2) * d3alphar_ddelta2_dtau;
    return dCaaa_dT;
}
exports.Get_dCaaa_dT = Get_dCaaa_dT;
function Get_dCaaw_dT(T) {
    var Tstar = 1; // [K]
    var rhobarstar = 1E3 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var theta = T / Tstar;
    var sum = 0;
    var c = [NaN, 0.482737E3, 0.105678E6, -0.656394E8, 0.294442E11, -0.319317E13];
    for (var i = 1; i <= 5; i++) {
        sum += c[i] * (1 - i) * Math.pow(theta, -i);
    }
    var dCaaw_dT = 1 / (Math.pow(rhobarstar, 2) * Tstar) * sum;
    return dCaaw_dT;
}
exports.Get_dCaaw_dT = Get_dCaaw_dT;
function Get_dCaww_dT(T) {
    var Tstar = 1; // [K]
    // NB: There seems to be an error in RP1485, section 3.3.2.3 says rhobarstar
    // should be 10^3 mol/dm3 for Caww but 1 mol/dm3 seems to yield the results in table A.3
    //double rhobarstar = 1E3 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var rhobarstar = 1 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    var theta = T / Tstar;
    var d = [NaN, -0.1072887E2, 0.347804E4, -0.383383E6, 0.334060E8];
    var sum1 = 0;
    for (var i = 1; i <= 4; i++) {
        sum1 += d[i] * Math.pow(theta, 1 - i);
    }
    var sum2 = 0;
    for (var i = 2; i <= 4; i++) {
        sum2 += d[i] * (1 - i) * Math.pow(theta, -i);
    }
    var dCaww_dT = -1 / (Math.pow(rhobarstar, 2) * Tstar) * Math.exp(sum1) * sum2;
    return dCaww_dT;
}
exports.Get_dCaww_dT = Get_dCaww_dT;
function Get_dCwww_dT(T) {
    var M_95 = 18.015268 / 1000; // [kg/kmol] -> [kg/mol]
    var rho_c = 322; // [kg/m3]
    var T_c = 647.096; // [K]
    var tau = T_c / T;
    var rhobar_c = rho_c / M_95;
    // NB: Using delta = 1E-10 yields the values in the table, using delta = 1E-12 does not!!
    //double delta = 1E-12;
    var delta = delta_zero;
    var d3alphar_ddelta2_dtau = IAPWS_95.Get_d3alphar_ddelta2_dtau(delta, tau);
    var dCwww_dT = -1 / (Math.pow(rhobar_c, 2) * T_c) * Math.pow(tau, 2) * d3alphar_ddelta2_dtau;
    return dCwww_dT;
}
exports.Get_dCwww_dT = Get_dCwww_dT;
